module.exports = __webpack_public_path__ + "media/images/icons/icon_plus_white-47f1bb4dc083526953b7b122aa53e44c.svg";